import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { ReplyTemplateActions, AppActions } from '@actions/index'
import { HttpApiService } from '@services/http-api.service';
import { of } from 'rxjs';
import Swal from 'sweetalert2';
import { ResponseModel } from '@models/response.model';
import { ReplyTemplateModel } from '@models/reply-template.model';

/**
 * AppEffects handles all side effects the app and
 * dispatches the correspondent actions and servides.
 */
@Injectable()
export class ReplyTemplateEffects {
    /**
     * AppEffects Constructor
     * @param actions$ 
     * @param httpApiService The HTTP service to build HTTP requests
     */
    constructor(
        private actions$: Actions,
        private httpApiService: HttpApiService) { }

    launchAlertMssg(title: string, message: string, type: any) {
        Swal.fire({
            title: title,
            html: message,
            icon: type,
            showCancelButton: false,
            confirmButtonText: 'OK'
        }).then(result => {
            // if(result.value && type == 'error') this.routerFacadeService.navigateTo$('admin-location/location-review-targets')
        })
    }

    saveReplyTemplate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReplyTemplateActions.saveReplyTemplate),
            switchMap(({ request }) =>
                this.httpApiService
                    .postRequest(request)
                    .pipe(
                        map(item => item as ReplyTemplateModel),
                        map(response => ReplyTemplateActions.saveReplyTemplateSuccess({ response })),
                        catchError(error => of(AppActions.appError({ error: error.message })))
                    )
            )
        ));

    getReplyTemplate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReplyTemplateActions.getReplyTemplate),
            switchMap(({ request }) =>
                this.httpApiService
                    .getRequest(request)
                    .pipe(
                        map(item => item as ReplyTemplateModel),
                        map(response => ReplyTemplateActions.getReplyTemplateSuccess({ response })),
                        catchError(error => of(AppActions.appError({ error: error.message })))
                    )
            )
        ));


}